import React, { createContext, useContext } from 'react';
import { useUpercutPermissions } from '@hooks/useUpercutPermissions';
import { useAuth } from './AuthContext';

interface PermissionContextValue {
    permissions: string[];
    loading: boolean;
    error: Error | null;
    hasPermission: (permission: string) => boolean;
    hasAnyPermission: (permissions: string[]) => boolean;
    hasAllPermissions: (permissions: string[]) => boolean;
    refresh: () => Promise<any>;
    
    // Role awareness
    userRole: string | null;
    isUpercut: boolean;
    isPro: boolean;
}

const PermissionContext = createContext<PermissionContextValue | undefined>(undefined);

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const permissionsState = useUpercutPermissions();
    const { user, isUpercut, isPro } = useAuth();

    // Pro users bypass permission system - grant all access
    // Permissions are only enforced for Upercut users
    const extendedPermissions: PermissionContextValue = isPro
        ? {
            permissions: ['*:*'], // Grant all permissions
            loading: false,
            error: null,
            hasPermission: () => true,
            hasAnyPermission: () => true,
            hasAllPermissions: () => true,
            refresh: async () => null,
            userRole: user?.role || null,
            isUpercut,
            isPro,
        }
        : {
            ...permissionsState,
            userRole: user?.role || null,
            isUpercut,
            isPro,
        };
        console.log(extendedPermissions)
    return (
        <PermissionContext.Provider value={extendedPermissions}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissionContext = () => {
    const context = useContext(PermissionContext);
    if (!context) {
        throw new Error('usePermissionContext must be used within PermissionProvider');
    }
    return context;
};
